export default "/7ee56fc642439642e071ad6692a1a8b95a874bf4/5ba84b7c5997e2a9223c26a23a6fa17e.svg";